import logoSmall from '../assets/logo-small.svg?url';

export class Header {
  constructor(cartCount = 3, config = null) {
    this.cartCount = cartCount;
    this.config = config || this.getDefaultConfig();
    this.paymentNotification = {
      show: false,
      message: '',
      status: 'idle',
      onClick: null
    };
  }

  getDefaultConfig() {
    return {
      name: 'Restaurant',
      branding: {
        logo: null
      }
    };
  }

  render() {
    const logoSrc = this.config.branding?.logo || logoSmall;
    const restaurantName = this.config.name || 'Restaurant';

    return `
      <div class="header">
        <div class="header-left">
          <div class="logo-container">
            ${this.config.branding?.logo ?
              `<button class="logo-btn" id="logo-btn" aria-label="Back to welcome screen">
                <img src="${logoSrc}" alt="${restaurantName} restaurant logo" class="logo-small">
              </button>` :
              ''}
          </div>
        </div>
        <div class="header-center">
          ${this.renderPaymentNotification()}
        </div>
        <div class="header-actions">
          <button class="search-btn" id="search-btn">
            <i class="fas fa-search"></i>
          </button>
          <button class="language-btn" id="language-btn">
            <i class="fas fa-globe"></i>
          </button>
          <button class="staff-call-btn" id="staff-call-btn">
            <i class="fas fa-bell"></i>
          </button>
          <button class="cart-btn" id="cart-btn">
            <i class="fas fa-receipt"></i>
            <span class="cart-count" id="cart-count">${this.cartCount}</span>
          </button>
        </div>
      </div>
    `;
  }

  renderPaymentNotification() {
    if (!this.paymentNotification.show) {
      return '';
    }

    const statusClass = `payment-notification-${this.paymentNotification.status}`;
    const icon = this.getPaymentNotificationIcon(this.paymentNotification.status);

    return `
      <div class="topbar-payment-notification ${statusClass}" id="topbar-payment-notification">
        <div class="payment-notification-content">
          <i class="fas ${icon}"></i>
          <span class="payment-notification-message">${this.paymentNotification.message}</span>
        </div>
      </div>
    `;
  }

  getPaymentNotificationIcon(status) {
    const icons = {
      'required': 'fa-credit-card',
      'pending': 'fa-clock',
      'processing': 'fa-spinner fa-spin',
      'success': 'fa-check-circle',
      'error': 'fa-exclamation-triangle',
      'idle': 'fa-info-circle'
    };
    return icons[status] || 'fa-info-circle';
  }

  bindEvents(onSearch, onCartClick, onLanguageClick, onStaffCallClick, onLogoClick, onPaymentNotificationClick) {
    document.getElementById('search-btn')?.addEventListener('click', onSearch);
    document.getElementById('language-btn')?.addEventListener('click', onLanguageClick);
    document.getElementById('staff-call-btn')?.addEventListener('click', onStaffCallClick);
    document.getElementById('cart-btn')?.addEventListener('click', onCartClick);
    document.getElementById('logo-btn')?.addEventListener('click', onLogoClick);

    const paymentNotification = document.getElementById('topbar-payment-notification');
    if (paymentNotification && this.paymentNotification.onClick) {
      paymentNotification.addEventListener('click', this.paymentNotification.onClick);
    }
  }

  updateCartCount(count) {
    this.cartCount = count;
    const cartCountElement = document.getElementById('cart-count');
    if (cartCountElement) {
      cartCountElement.textContent = count;
      cartCountElement.style.transform = 'scale(1.3)';
      setTimeout(() => {
        cartCountElement.style.transform = 'scale(1)';
      }, 200);
    }
  }

  updatePaymentNotification(show = false, message = '', status = 'idle', onClick = null) {

    this.paymentNotification = {
      show,
      message,
      status,
      onClick
    };

    const headerCenter = document.querySelector('.header-center');
    if (headerCenter) {
      headerCenter.innerHTML = this.renderPaymentNotification();

      const paymentNotification = document.getElementById('topbar-payment-notification');
      if (paymentNotification && onClick) {
        paymentNotification.addEventListener('click', onClick);
      }
    } else {
    }
  }
}